import React from 'react'

import QrCode from './QrCode'
import ScanInstructions from './ScanInstructions'

function ScanContainer() {
  return (
    <div className="flex p-8 rounded bg-white shadow space-x-6">
      <QrCode />
      <ScanInstructions />
    </div>
  )
}

export default ScanContainer
